import { render, staticRenderFns } from "./processEdit.vue?vue&type=template&id=01f2659e&scoped=true&"
import script from "./processEdit.vue?vue&type=script&lang=ts&"
export * from "./processEdit.vue?vue&type=script&lang=ts&"
import style0 from "./processEdit.vue?vue&type=style&index=0&id=01f2659e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2659e",
  null
  
)

export default component.exports